'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'plane';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f072';
var svgPathData = ['M65.3 160l29.5 88.4 2.5 7.6-2.5 7.6L65.3 352 92 352l40.8-54.4L140 288l12 0 74.3 0 31.8 0-8.7 30.6L207.8 464l34.3 0 93.7-163.9 6.9-12.1 13.9 0L470 288c9.7 0 26-4.4 39.8-12.8C525 266.1 528 258.4 528 256c0-.6-.2-2.8-3.3-6.7c-3.1-3.9-8.1-8.2-14.9-12.3c-14-8.5-30.2-13-39.7-13l-113.5 0-13.9 0-6.9-12.1L242.1 48l-34.3 0 41.5 145.4 8.7 30.6-31.8 0L152 224l-12 0-7.2-9.6L92 160l-26.7 0z', 'M562.1 219.3c7.6 9.5 13.9 22 13.9 36.7c0 29.1-23 49.4-41.4 60.4C514.9 328.2 490.2 336 470 336l-99.5 0L276.8 499.9 269.9 512 256 512l-80 0-31.8 0 8.7-30.6L194.5 336 164 336l-40.8 54.4L116 400l-12 0-72 0-33.3 0L9.2 368.4 46.7 256 9.2 143.6-1.3 112 32 112l72 0 12 0 7.2 9.6L164 176l30.5 0L152.9 30.6 144.2 0 176 0l80 0 13.9 0 6.9 12.1L370.5 176l99.5 0c20.3 0 45.1 8.1 64.6 20c10 6.1 19.9 13.8 27.5 23.3zM509.8 237c-14-8.5-30.2-13-39.7-13l-113.5 0-13.9 0-6.9-12.1L242.1 48l-34.3 0 41.5 145.4 8.7 30.6-31.8 0L152 224l-12 0-7.2-9.6L92 160l-26.7 0 29.5 88.4 2.5 7.6-2.5 7.6L65.3 352 92 352l40.8-54.4L140 288l12 0 74.3 0 31.8 0-8.7 30.6L207.8 464l34.3 0 93.7-163.9 6.9-12.1 13.9 0L470 288c9.7 0 26-4.4 39.8-12.8C525 266.1 528 258.4 528 256c0-.6-.2-2.8-3.3-6.7c-3.1-3.9-8.1-8.2-14.9-12.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;